var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 24,
    height: 24,
    transform: "translate(268 121)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(-268 -121)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(266.286 119.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M5.143,18v-.857H3.429V18a6,6,0,0,0,6,6H12V22.286H9.429A4.286,4.286,0,0,1,5.143,18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M20.571,9.429v.857h1.714V9.429a6,6,0,0,0-6-6H13.714V5.143h2.571a4.286,4.286,0,0,1,4.286,4.286Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M9.429,9.429H4.286A2.571,2.571,0,0,0,1.714,12v1.714H3.429V12a.857.857,0,0,1,.857-.857H9.429a.857.857,0,0,1,.857.857v1.714H12V12A2.571,2.571,0,0,0,9.429,9.429Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M6.857,8.571A3.429,3.429,0,1,0,3.429,5.143,3.429,3.429,0,0,0,6.857,8.571Zm0-5.143A1.714,1.714,0,1,1,5.143,5.143,1.714,1.714,0,0,1,6.857,3.429Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M23.143,21.429H18A2.571,2.571,0,0,0,15.429,24v1.714h1.714V24A.857.857,0,0,1,18,23.143h5.143A.857.857,0,0,1,24,24v1.714h1.714V24a2.571,2.571,0,0,0-2.571-2.571Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M17.143,17.143a3.429,3.429,0,1,0,3.429-3.429A3.429,3.429,0,0,0,17.143,17.143Zm5.143,0a1.714,1.714,0,1,1-1.714-1.714A1.714,1.714,0,0,1,22.286,17.143Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.fe08531cdf68c360711222a0c92ac24e.svg";
export { ForwardRef as ReactComponent };